import { ui } from "aaa";
import { themeColors } from "muiTheme";
import * as React from "react";

type Variants = "default" | "dense";

const getVariantHeight = (variant: Variants) => {
    switch (variant) {
        case "dense":
            return 56;
        case "default":
        default:
            return 78;
    }
};

export const SettingsButton = ({
    icon,
    border,
    borderRadius,
    onClick,
    children,
    variant = "default",
    style,
}: {
    icon?: React.ReactNode;
    border: "top" | "bottom" | "both" | "none",
    borderRadius: "top" | "bottom" | "both" | "none",
    onClick?: () => void;
    children: any,
    variant?: "default" | "dense",
    style?: React.CSSProperties
}) => (
    <div
        role={onClick ? "button" : ""}
        tabIndex={onClick ? 0 : undefined}
        className="theme-sidentity-settings-button-colors"
        style={{
            boxSizing: "border-box",
            height: getVariantHeight(variant),
            padding: 16,
            display: "flex",
            alignItems: "center",
            gap: 16,
            cursor: onClick ? "pointer" : "auto",
            borderTopLeftRadius: borderRadius === "top" || borderRadius === "both" ? 10 : undefined,
            borderTopRightRadius: borderRadius === "top" || borderRadius === "both" ? 10 : undefined,
            borderBottomLeftRadius: borderRadius === "bottom" || borderRadius === "both" ? 10 : undefined,
            borderBottomRightRadius: borderRadius === "bottom" || borderRadius === "both" ? 10 : undefined,
            borderBottomWidth: 1,
            borderBottomStyle: (border === "bottom" || border === "both") ? "solid" : "none",
            borderTopWidth: 1,
            borderTopStyle: (border === "top" || border === "both") ? "solid" : "none",
            borderColor: ui.isDarkMode ? themeColors.d_grey_100 : themeColors.grey_200,
            ...style,
        }}
        onClick={onClick}
        onKeyUp={(e) => {
            if (onClick && (e.keyCode === 13 || e.keyCode === 32)) {
                onClick();
            }
        }}
    >
        {icon && (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 48,
                    height: 48,
                    borderRadius: "100%",
                    backgroundColor: ui.isDarkMode ? "rgba(25, 156, 249, 0.2)" : "#EEF4FE"
                }}
            >
                {icon}
            </div>
        )}
        <div
            style={{
                display: "flex",
                flexGrow: 1,
                alignItems: "center",
                height: "100%",
            }}
        >
            {children}
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./src/components/loginManagement/components/SettingsButton.tsx